(() => {
  class MFMobileDock {
    constructor(section) {
      this.section = section;
      this.dock = section.querySelector('.mf-mobile-dock');
      this.cartCount = section.querySelector('[data-mf-cart-count]');
      this.items = section.querySelectorAll('[data-mf-dock-item]');

      if (!this.dock) return;

      this.setGridCount();
      this.setActiveItem();
      this.updateCartCount();
      this.bindEvents();
    }

    setGridCount() {
      this.dock.style.setProperty('--mf-dock-count', this.items.length || 5);
    }

    setActiveItem() {
      const currentPath = window.location.pathname.replace(/\/$/, '') || '/';

      this.items.forEach((item) => {
        const href = item.getAttribute('href');

        if (!href || href === '#') return;

        try {
          const itemPath = new URL(href, window.location.origin).pathname.replace(/\/$/, '') || '/';

          if (itemPath === currentPath) {
            item.classList.add('is-active');
          }
        } catch (error) {
          return;
        }
      });
    }

    async updateCartCount() {
      if (!this.cartCount) return;

      try {
        const response = await fetch('/cart.js', {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) return;

        const cart = await response.json();
        const count = Number(cart.item_count || 0);

        this.cartCount.textContent = count;
        this.cartCount.classList.toggle('is-empty', count <= 0);
      } catch (error) {
        return;
      }
    }

    bindEvents() {
      document.addEventListener('cart:updated', () => this.updateCartCount());
      document.addEventListener('cart:refresh', () => this.updateCartCount());
      document.addEventListener('ajaxProduct:added', () => this.updateCartCount());

      window.addEventListener('pageshow', () => this.updateCartCount());

      if (window.__mfDockFetchPatched) return;

      const originalFetch = window.fetch;

      if (typeof originalFetch !== 'function') return;

      window.__mfDockFetchPatched = true;

      window.fetch = async (...args) => {
        const response = await originalFetch(...args);

        try {
          const requestUrl = typeof args[0] === 'string' ? args[0] : args[0]?.url;

          if (
            requestUrl &&
            (
              requestUrl.includes('/cart/add') ||
              requestUrl.includes('/cart/change') ||
              requestUrl.includes('/cart/update') ||
              requestUrl.includes('/cart/clear')
            )
          ) {
            setTimeout(() => {
              document.dispatchEvent(new CustomEvent('cart:updated'));
            }, 250);
          }
        } catch (error) {
          return response;
        }

        return response;
      };
    }
  }

  const init = () => {
    document.querySelectorAll('[data-mf-mobile-dock]').forEach((section) => {
      if (section.dataset.mfDockReady === 'true') return;

      section.dataset.mfDockReady = 'true';
      new MFMobileDock(section);
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();